

import React from 'react'
import classNames from 'classnames'
import ReduxStores from '../../../../stores/connects'
import DropDown from './dropDown.jsx'
import { string, func, object, bool } from 'prop-types'

class Navbar extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  validDropDown () { // Only show dropdown if on specific pages
    const { pageName, linkData: { pageMatch, links } } = this.props
    if (!pageName || !pageMatch) return true
    if (!links) return false
    const isHomepage = pageName === 'index' || pageName === 'index-2' || pageName === 'index-3'
    if (isHomepage) return true
    const pageRegExp = RegExp(pageMatch)
    if (pageRegExp.test(pageName)) return true
    return false
  }

  handleClick (e) {
    if (!this.validDropDown()) return true
    const { handleClick, linkData: { classCheck }, active } = this.props
    e.preventDefault()
    if (classCheck === active) handleClick()
    else handleClick(classCheck)
  }

  checkExclude () {
    if (!this.props.agentData || !this.props.agentData.agent || !this.props.agentData.groupCode) return false
    const { linkData: { excludeAgent = [], excludeGroup = [] } } = this.props
    const { agentData: { agent, groupCode } } = this.props
    let excludedCodes = [ ...excludeAgent, ...excludeGroup ].join(',').toUpperCase().split(',')
    if (excludedCodes.indexOf(agent.toString().toUpperCase()) !== -1 || excludedCodes.indexOf(groupCode.toString().toUpperCase()) !== -1) return true
    return false
  }

  render () {
    const { listGroup, active, visible, linkData } = this.props
    const { header, classCheck, columns, canSell, smallDropdown, mainLink } = linkData
    const { agentData: { OptionFlags } } = this.props
    if (this.checkExclude()) return null
    if (OptionFlags && canSell && OptionFlags[canSell] === 'N') return null
    const validDropDown = this.validDropDown()
    const activeClass = classNames({
      'open': classCheck === active,
      'dropdown': validDropDown,
      'dropdown-long': !smallDropdown,
      'hide': !visible
    })
    const singleClass = classNames({
      'single': !(/<br/).test(header)
    })
    const href = this.validDropDown() ? '#' : mainLink
    return (
      <li className={activeClass}>
        <a href={href} className={singleClass} data-hxtrack-name={'header_dropdown_long_' + listGroup.toLowerCase()} data-hxtrack-value={classCheck === active ? 'closed' : 'opened'} aria-haspopup={validDropDown} data-toggle={validDropDown ? 'dropdown' : null} onClick={this.handleClick} target='_parent'>
          <span dangerouslySetInnerHTML={{ __html: header }} />
          { this.validDropDown() && <span className='caret' /> }
        </a>
        { this.validDropDown() && <DropDown OptionFlags={OptionFlags} columns={columns} /> }
      </li>
    )
  }
}

Navbar.propTypes = {
  handleClick: func.isRequired,
  linkData: object.isRequired,
  pageName: string,
  active: string,
  visible: bool,
  listGroup: string
}
Navbar.defaultProps = {
  visible: true,
  agentData: {}
}

export default ReduxStores(Navbar, ['agents'], true)
